import React, { useEffect, useState } from "react";
import ShowTable from "./showTable";
import { getRquest } from "../../api";

function BanSocialMediaTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getRquest(
        "social-media-policies?populate=*&pagination[pageSize]=500"
      );
      // Extracting and transforming data to a flat structure
      const transformedData = response.data.map((item, index) => {
        const { attributes } = item;
        return {
          Sno: index + 1,
          organisation: attributes.organisation,
          policy_key_points: attributes.policy_key_points,
          source: attributes.source,
          year: attributes.year,
          keywords: attributes.keywords.data[0]?.attributes.name || "",
          transgessions:
            attributes.transgessions.data[0]?.attributes.name || "",
          organisation_type:
            attributes.organisation_types.data[0]?.attributes.name || "",
        };
      });
      setData(transformedData);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Error fetching data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const DetailsSort = data
    ?.sort((a, b) => {
      return b.year - a.year;
    })
    .map((item, index) => ({ ...item, index }));
  const columns = [
    {
      name: "S.No",
      selector: (row) => row.index+1,
      minWidth: "50px",
    },
    {
      name: "Policy Key Points",
      selector: (row) => row.policy_key_points,
      minWidth: "750px",
      wrap: true,
      style: {
        margin: "10px 0px",
      },
      center: true,
    },
    {
      name: "Organisation",
      selector: (row) => row.organisation ,
      minWidth: "250px",
      center:true,
      wrap:true,
    },
    {
      name: "Source",
      selector: (row) => {
        return <a href={row.source}>{row.source}</a>;
      },
      minWidth: "300px",
      wrap: true,
      center:true,
      style: {
        margin: "10px 0px",
      },
    },
    {
      name: "Year",
      selector: (row) => row.year,
      minWidth: "150px",
      wrap: true,
      center:true,
    },
    {
      name: "Keywords",
      selector: (row) => row.keywords,
      minWidth: "200px",
      wrap: true,
    },
    {
      name: "Transgessions",
      selector: (row) => row.transgessions,
      minWidth: "150px",
      wrap: true,
      center: true,
    },
    {
      name: "Organisation Type",
      selector: (row) => row.organisation_type,
      minWidth: "180px",
      wrap: true,
      center: true,
    },
  ];

  return <ShowTable title={"Restrictive Social Media Policies bans"} columns={columns} Data={DetailsSort} />;
}

export default BanSocialMediaTable;
